import { SECTION_ITEM_TYPES } from '../Constants';

export default function masterValidate(learningAsset) {
    let fault = 0;
    const messages = [];

    // const punctuations = ['.', ',', '!', '?', ';', ':'];

    // const learningAssetName = learningAsset.name || '';
    // const learningAssetNameLastChar = learningAssetName[learningAssetName.length - 1];

    // learning asset's name can not end with a punctuation
    // if (punctuations.includes(learningAssetNameLastChar)) {
    //   fault += 1;
    //   messages.push(`Asset's name (${learningAssetName}) can not end with a punctuation`);
    // }

    if (learningAsset.sections && learningAsset.sections.length) {
        let hasVideoSectionItem = false;
        learningAsset.sections.forEach((section, i) => {
            const sectionIndex = i + 1;
            section.sectionItems.forEach((sectionItem, j) => {
                const sectionItemIndex = j + 1;

                // custom validation for different sectionItem types
                if (sectionItem.type.toLocaleUpperCase() === SECTION_ITEM_TYPES.SHORT_ESSAY_RESULT) {
                    if (sectionItem.content.items && sectionItem.content.items.length) {
                        sectionItem.content.items.forEach((item, k) => {
                            const itemIndex = k + 1;
                            if (!item.label) {
                                fault += 1;
                                messages.push(
                                    `Section ${sectionIndex}.${sectionItemIndex} (${sectionItem.name} - ${sectionItem.type}) item #${itemIndex} requires Label`
                                );
                            }
                        });
                    }
                }

                if (
                    learningAsset.type === 'VIDEO' &&
                    !hasVideoSectionItem &&
                    sectionItem.type.toLocaleUpperCase() === SECTION_ITEM_TYPES.DYNAMIC_RICH_TEXT_CONTENT &&
                    sectionItem.content.blocks.length
                ) {
                    sectionItem.content.blocks.forEach((block) => {
                        if (block.layout === 'TOP_TEXT_BOTTOM_VIDEO' && block.videoUrl && block.videoUrl.length) {
                            hasVideoSectionItem = true;
                        }
                    });
                }

                // additional custom validations can go here
            });
        });
        if (learningAsset.type === 'VIDEO' && !hasVideoSectionItem) {
            fault += 1;
            messages.push("Learning asset of type 'Video' must include at least one video item.");
        }
    }

    return {
        fault,
        messages
    };
}
